export { default } from "./InputLabel.js";
export { default as inputLabelClasses } from "./inputLabelClasses.js";
export * from "./inputLabelClasses.js";